export interface WorkTimeEmployeeTileAbsenceDto {
    name?: string;
    color?: string | null;
    code?: string;
}

export type WorkTimeAttendanceStatus = 'present' | 'on_break' | 'absent';

export interface WorkTimeEmployeeTileSummaryDto {
    attendanceStatus?: WorkTimeAttendanceStatus;
    attendance_status?: WorkTimeAttendanceStatus;
    monthBalanceMinutes?: number;
    month_balance_minutes?: number;
    availableTimeAccountMinutes?: number | null;
    available_time_account_minutes?: number | null;
    todayAbsence?: WorkTimeEmployeeTileAbsenceDto | null;
    today_absence?: WorkTimeEmployeeTileAbsenceDto | null;
}

export class WorkTimeEmployeeTileSummary {
    attendanceStatus: WorkTimeAttendanceStatus;
    monthBalanceMinutes: number;
    availableTimeAccountMinutes: number | null;
    todayAbsence: WorkTimeEmployeeTileAbsenceDto | null;

    constructor(dto: WorkTimeEmployeeTileSummaryDto | null | undefined) {
        this.attendanceStatus = dto?.attendanceStatus
            ?? dto?.attendance_status
            ?? 'absent';
        this.monthBalanceMinutes = Number(
            dto?.monthBalanceMinutes ?? dto?.month_balance_minutes ?? 0,
        );
        const available = dto?.availableTimeAccountMinutes ?? dto?.available_time_account_minutes;

        this.availableTimeAccountMinutes = available == null ? null : Number(available);

        const rawAbsence = dto?.todayAbsence ?? dto?.today_absence;

        this.todayAbsence = rawAbsence?.name
            ? {
                name: rawAbsence.name,
                color: rawAbsence.color ?? null,
                code: rawAbsence.code,
            }
            : null;
    }
}
